<div class="row">
    <div style="margin-bottom: 10px;display:flex;justify-content: flex-center;">
        <h1>Użytkownik</h1>
    </div>
    <div style="margin-bottom: 10px;display:flex;justify-content: flex-end;">
    </div>
</div>

<hr>
<div class="row">
    <div class="col-12">
        <h3>User Rekbots</h3>
        <div fxLayoutAlign="center center">
            <mat-form-field fxFlex="40%">
                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtruj">
            </mat-form-field>
        </div>
        <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- serial_no Column -->
            <ng-container matColumnDef="serial_no">
                <th style="width:45%;" mat-header-cell *matHeaderCellDef mat-sort-header> SERIAL NO </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- IP Column -->
            <ng-container matColumnDef="ipv4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> IP </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>
        <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
        </mat-paginator>

    </div>
</div>